import { PayloadAction } from '@reduxjs/toolkit';
import { DocumentationPills, GlobalState, ParsedFieldsByObject } from './globalReducerTypes';
import { RootState } from '../index';
import { ObjectData } from '../../components/parser/ParserTypes';
import {
  calcParsedRules,
  calcParsedRecordTypes,
  calcLayouts,
} from '../../components/parser/parserUtils';

type ParserReducersProps = {
  addParsedDataToDocumentation: (
    state: GlobalState,
    action: PayloadAction<{
      response: ObjectData[];
      objectName: string;
      crmOrgId: string;
      fieldsParsedOnDemand: ParsedFieldsByObject;
      pills: DocumentationPills;
    }>,
  ) => void;
};

export const parserReducer: ParserReducersProps = {
  addParsedDataToDocumentation: (state, action) => {
    const { objectName, crmOrgId, response, fieldsParsedOnDemand, pills } = action.payload;
    const newObjectRules = calcParsedRules(response);
    const newObjectRecordTypes = calcParsedRecordTypes(response);
    const newObjectLayouts = calcLayouts(response);
    const oldData = state.environments[crmOrgId].data?.documentation ?? {};

    if (state.environments[crmOrgId].data?.documentation) {
      state.environments[crmOrgId].data.documentation = {
        ...oldData,
        layouts: { ...oldData.layouts, ...newObjectLayouts },
        parsedRules: [...(oldData.parsedRules ?? []), ...newObjectRules],
        parsedRecordTypes: [...(oldData.parsedRecordTypes ?? []), ...newObjectRecordTypes],
        parsedObjectNames: [...(oldData.parsedObjectNames ?? []), objectName],
        parsedFields: { ...(oldData.parsedFields ?? {}), ...fieldsParsedOnDemand },
        pills: { ...(oldData.pills ?? {}), ...pills },
      };
    }
  },
};

export const selectParserInfo = (crmOrgId: string) => (state: RootState) =>
  state.global.environments[crmOrgId]?.data?.documentation;

export const selectParsedFields = (crmOrgId: string) => (state: RootState) =>
  state.global.environments[crmOrgId]?.data?.documentation?.parsedFields;

export const selectParsedRecordTypes = (crmOrgId: string) => (state: RootState) =>
  state.global.environments[crmOrgId]?.data?.documentation?.parsedRecordTypes;

export const selectParsedRules = (crmOrgId: string) => (state: RootState) =>
  state.global.environments[crmOrgId]?.data?.documentation?.parsedRules;

export const selectParsedObjects = (crmOrgId: string) => (state: RootState) =>
  state.global.environments[crmOrgId]?.data?.documentation?.parserObjects;

export const selectSaltoObjectTypes = (crmOrgId: string) => (state: RootState) =>
  state.global.environments[crmOrgId]?.data?.documentation?.saltoObjectTypes;

export const selectOnlyActiveParsedRules = (crmOrgId: string) => (state: RootState) =>
  state.global.environments[crmOrgId]?.data?.documentation?.onlyActiveParsedRules;

export const selectRelatedObjectsByObjectName = (crmOrgId: string) => (state: RootState) =>
  state.global.environments[crmOrgId]?.data?.documentation?.relatedObjects;

export const selectLayoutsByObjectName = (crmOrgId: string) => (state: RootState) =>
  state.global.environments[crmOrgId]?.data?.documentation?.layouts;
